import * as React from 'react';
import {
  EXERCISE_SHORT_ANSWER,
  EXERCISE_SHORT_ANSWER_BLANK,
  EXERCISE_SHORT_ANSWER_QUESTION,
  EXERCISE_SHORT_ANSWER_QUESTIONS,
  ExerciseShortAnswerOptions,
} from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const ExerciseShortAnswer = dynamicEditorComponent(() =>
  import('./components/ExerciseShortAnswer').then((mod) => mod.ExerciseShortAnswer)
);
const ExerciseShortAnswerQuestions = dynamicEditorComponent(
  () =>
    import('./components/ExerciseShortAnswerQuestions').then(
      (mod) => mod.ExerciseShortAnswerQuestions
    ),
  {
    dependsOn: ExerciseShortAnswer,
  }
);
const ShortAnswerBlank = dynamicEditorComponent(
  () => import('./components/ShortAnswerBlank').then((mod) => mod.ShortAnswerBlank),
  {
    dependsOn: ExerciseShortAnswer,
  }
);
const ShortAnswerQuestion = dynamicEditorComponent(
  () => import('./components/ShortAnswerQuestion').then((mod) => mod.ShortAnswerQuestion),
  {
    dependsOn: ExerciseShortAnswer,
  }
);

export const renderElementExerciseShortAnswer =
  (options?: ExerciseShortAnswerOptions) => (props) => {
    const { element } = props;

    switch (element.type) {
      case EXERCISE_SHORT_ANSWER:
        return <ExerciseShortAnswer {...props} />;

      case EXERCISE_SHORT_ANSWER_QUESTIONS:
        return <ExerciseShortAnswerQuestions {...props} />;

      case EXERCISE_SHORT_ANSWER_QUESTION:
        return <ShortAnswerQuestion {...props} />;

      case EXERCISE_SHORT_ANSWER_BLANK:
        return <ShortAnswerBlank {...props} />;

      default:
        return undefined;
    }
  };
